module.exports = __webpack_public_path__ + "static/media/partner-logo16.7788473e.png";